/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (g-force)`)
};

const es_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (fuerza g)`)
};

const de_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (G-Kraft)`)
};

const nl_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (g-kracht)`)
};

const fr_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (force g)`)
};

const it_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (forza G)`)
};

const pt_br2_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (força g)`)
};

const pt_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF (força g)`)
};

const ja_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF(g力)`)
};

const zh_gf_rcf_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF（离心力）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_rcf_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_rcf_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_rcf_label", locale)
	if (locale === "en") return en_gf_rcf_label(inputs)
	if (locale === "es") return es_gf_rcf_label(inputs)
	if (locale === "de") return de_gf_rcf_label(inputs)
	if (locale === "nl") return nl_gf_rcf_label(inputs)
	if (locale === "fr") return fr_gf_rcf_label(inputs)
	if (locale === "it") return it_gf_rcf_label(inputs)
	if (locale === "pt-BR") return pt_br2_gf_rcf_label(inputs)
	if (locale === "pt") return pt_gf_rcf_label(inputs)
	if (locale === "ja") return ja_gf_rcf_label(inputs)
	return zh_gf_rcf_label(inputs)
};